<template>
  <Modal v-model="modalUpdateNote" footer-hide width="1000">
    <p slot="header" class="text-center">
        <span>更新日志</span>
    </p>
    <List v-if="historyUpdateNotes.length>0">
      <ListItem v-for="(note,index) in historyUpdateNotes" :key="index">
          <ListItemMeta>
            <Divider slot="title" orientation="left" dashed style="margin: 5px 0;">
              {{ note.createTime+'（' + note.userName + '）'  }}
            </Divider>
            <template slot="description">
              <p>更新后：{{ note.updateAfter }}</p>
              <p class="remark m-t-10">更新前: {{ note.updateBefore }}</p>
            </template>
          </ListItemMeta>
      </ListItem>
    </List>
    <p v-else class="text-center remark p-t-10">暂无数据</p>
  </Modal>
</template>

<script>
import { getServiceVersionModifyList } from '@/api/msp/serviceversion'

export default {
  data () {
    return {
      modalUpdateNote: false,

      historyUpdateNotes: []
    }
  },
  methods: {
    showModal (serviceVersionId) {
      this.modalUpdateNote = true

      getServiceVersionModifyList({ serviceVersionId: serviceVersionId }).then(res => {
        this.historyUpdateNotes = res
      })
    }
  }
}
</script>
